import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, DownloadIcon, PrinterIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroBadges, images } from '../data/salesCopy';
export function Hero() {
  return <section className="w-full bg-night" data-id="element-115" data-mp="9l37jlcn0s87">
      <div className="mx-auto max-w-5xl px-4 pb-10 pt-8 text-center sm:px-5 sm:pb-16 sm:pt-14" data-id="element-116" data-mp="4m8n6ez0uvlz">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-117" data-mp="12a0lxddqa4vo">
          <p className="flex items-center justify-center gap-3 text-[10px] font-semibold uppercase tracking-[0.28em] text-gold sm:text-xs" data-id="element-118" data-mp="sbb2vha3iedu">
            <span className="h-px w-8 bg-gold" aria-hidden="true" data-id="element-119" data-mp="nb6lzq59zhn3" />
            The complete method for guitar teachers
          </p>

          <h1 className="mx-auto mt-4 max-w-4xl font-display text-[2rem] uppercase leading-[0.95] tracking-tight text-cream sm:mt-5 sm:text-6xl lg:text-7xl" data-id="element-120" data-mp="3czfl7z4xc761">
            Plan your whole term
            <span className="mt-1 block text-gold" data-id="element-121" data-mp="3j9ahhe4fas5o">of guitar lessons</span>
          </h1>

          <p className="mx-auto mt-4 max-w-2xl font-serif text-base italic leading-snug text-cream-muted sm:mt-5 sm:text-xl" data-id="element-122" data-mp="3o73ouahgps7j">
            The “Print &amp; Go” system for guitar teachers that turns your lesson planning from{' '}
            <span className="text-gold" data-id="element-123" data-mp="3eb91x367hayy">chaotic</span> into{' '}
            <span className="text-cream" data-id="element-124" data-mp="30h9ebzkm8fqg">obvious</span>.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.55,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mt-8 rounded-2xl border border-line bg-panel p-1.5 shadow-lift sm:mt-10 sm:p-4" data-id="element-125" data-mp="359j9pv4i2804">
          <img src={images.heroMockup} alt="The complete guitar teaching bundle shown on a monitor with the six bonus workbooks on tablets" className="w-full rounded-xl" data-id="element-126" data-mp="2hjox9eo3elge" />
          <span className="absolute -top-3 right-3 rounded-full bg-gold px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.12em] text-night sm:right-6 sm:px-4 sm:text-xs" data-id="element-127" data-mp="s44itpsj1piy">
            6 volumes + 6 bonuses
          </span>
        </motion.div>

        <div className="mx-auto mt-7 max-w-xl sm:mt-9" data-id="element-128" data-mp="ddwz76qsa0go">
          <CtaButton size="large" placement="hero" label="I want the complete pack for $27" mobileLabel="Get the pack for $27" note="Secure payment · PDFs sent by email · 10-day guarantee" data-id="element-129" data-mp="dbaq32o8vcwc" />
        </div>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-medium text-cream-muted sm:text-sm" data-id="element-130" data-mp="110wovp0pfq3t">
          <li className="flex items-center gap-2" data-id="element-131" data-mp="3lsp2bagmmdcu">
            <DownloadIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-132" data-mp="3lui86njf0tjs" />
            Delivered by email today
          </li>
          <li className="flex items-center gap-2" data-id="element-133" data-mp="3htpyjt6msmmz">
            <PrinterIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-134" data-mp="1xacf521xbhsp" />
            PDF ready to print
          </li>
          <li className="flex items-center gap-2" data-id="element-135" data-mp="21bfxpwbcvrxm">
            <span className="flex items-center gap-0.5" aria-hidden="true" data-id="element-136" data-mp="269he29hedd5e">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold text-gold" data-id="element-137" data-mp="2b1hh4asrkm67" data-mpi={i} />)}
            </span>
            <span className="font-semibold text-cream" data-id="element-138" data-mp="2fzj3p5pef3mf">4.9/5</span> · teachers worldwide
          </li>
        </ul>
      </div>

      <div className="border-y border-line bg-night-deep" data-id="element-139" data-mp="2p0h8vrbkph6l">
        <ul className="mx-auto grid max-w-6xl grid-cols-1 gap-x-8 gap-y-3 px-4 py-6 sm:grid-cols-2 sm:px-5 lg:grid-cols-3" data-id="element-140" data-mp="2p10fwczoql5u">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-2.5 text-[15px] text-cream" data-id="element-141" data-mp="umzky379aib1">
              <CheckIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-142" data-mp="zl0zcatqltg6" />
              {badge}
            </li>)}
        </ul>
      </div>
    </section>;
}